import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/Member.css';

export default function WithdrawalResult({ closeModal }: any) {
  const navigate = useNavigate();
  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <>
      <div className="withdrawal_wrap">
        <h3>
          그동안 어바웃피싱을 <br />
          이용해주셔서 감사합니다
        </h3>
        <div className="withdrawal_result">
          <p className="sub_tit">
            이별의 아쉬움보다는 다시 만나길 바라는 설레는 <br />
            마음으로 더욱더 발전하는 서비스가 되겠습니다.
          </p>
          <img className="badge_img" src="/images/withdrawal_badge.png" alt="" />
        </div>
        <div className="btn_box">
          <button
            onClick={() => {
              closeModal();
              navigate('/');
              window.localStorage.clear();
              window.location.reload();
            }}
          >
            홈으로 돌아가기
          </button>
        </div>
      </div>
    </>
  );
}
